(function () {
  "use strict";

  if (!window.DNB) {
    return;
  }

  window.DNB.register(function () {
    if (!window.gsap || !window.ScrollTrigger) {
      return;
    }

    var initTextOpacity = function (scope) {
      var root = scope || document;
      var targets = root.querySelectorAll("[data-text-opacity]");
      if (!targets.length) {
        return;
      }

      var isMobile =
        typeof window.matchMedia === "function" &&
        window.matchMedia("(max-width: 640px)").matches;

      window.gsap.utils.toArray(targets).forEach(function (target) {
        if (target.dataset.textOpacityReady === "true") {
          return;
        }
        target.dataset.textOpacityReady = "true";
        var triggerElement =
          target.closest("[data-scroll-section]") || target.closest("section") || target;

        var baseTrigger = {
          trigger: triggerElement,
          start: isMobile ? "top 85%" : "10% bottom",
          end: isMobile ? "bottom 55%" : "top 50%",
          scrub: !isMobile
        };
        if (isMobile) {
          baseTrigger.toggleActions = "play none none reverse";
        }

        if (window.DNB.scroller) {
          baseTrigger.scroller = window.DNB.scroller;
        }

        window.gsap.fromTo(
          target,
          { opacity: 0.2 },
          {
            opacity: 1,
            ease: "none",
            duration: isMobile ? 0.6 : 0.1,
            scrollTrigger: baseTrigger
          }
        );
      });
    };

    var initTextOpacityV2 = function (scope) {
      var root = scope || document;
      var v2Targets = root.querySelectorAll("[data-text-opacity-v2]");
      if (!v2Targets.length) {
        return;
      }

      var isMobile =
        typeof window.matchMedia === "function" &&
        window.matchMedia("(max-width: 640px)").matches;

      window.gsap.utils.toArray(v2Targets).forEach(function (target) {
        if (target.dataset.textOpacityV2Ready === "true") {
          return;
        }
        target.dataset.textOpacityV2Ready = "true";

        var triggerElement =
          target.closest("[data-scroll-section]") || target.closest("section") || target;

        var triggerOptions = {
          trigger: triggerElement,
          start: isMobile ? "top 85%" : "10% bottom",
          end: isMobile ? "bottom 55%" : "top 50%",
          scrub: !isMobile
        };
        if (isMobile) {
          triggerOptions.toggleActions = "play none none reverse";
        }

        if (window.DNB.scroller) {
          triggerOptions.scroller = window.DNB.scroller;
        }

        if (!window.Splitting) {
          window.gsap.fromTo(
            target,
            { opacity: 0.2 },
            {
              opacity: 1,
              ease: "none",
              scrollTrigger: triggerOptions
            }
          );
          return;
        }

        if (!target.hasAttribute("data-splitting")) {
          target.setAttribute("data-splitting", "words");
        }

        window.Splitting({ target: target, by: "words" });

        var words = target.querySelectorAll(".word");
        if (!words.length) {
          return;
        }

        window.gsap.set(words, { opacity: 0.2 });
        window.gsap.to(words, {
          opacity: 1,
          ease: "none",
          duration: isMobile ? 0.6 : 0.1,
          stagger: { each: isMobile ? 0.04 : 0.06, from: "start" },
          scrollTrigger: triggerOptions
        });
      });
    };

    window.DNB.textOpacityInit = initTextOpacity;
    window.DNB.textOpacityV2Init = initTextOpacityV2;

    initTextOpacity();
    initTextOpacityV2();
  });
})();
